import {useSelector} from 'react-redux';

export default () =>
	useSelector(({paansuserdata}) => {
		const isPaansDataLoaded = Object.keys(paansuserdata)?.length > 0;
		const isPaansValid = paansuserdata?.isPaansEnabled === false || paansuserdata?.hasAccepted === true;
		const paansRedirectUrl = paansuserdata?.redirectUrl ?? null;
		return {isPaansDataLoaded, isPaansValid, paansRedirectUrl};
	});
